import React from 'react';
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      return <Navigate to="/" replace />;
    }
    return children;
  } catch (e) {
    // If any error reading storage, deny access
    return <Navigate to="/" replace />;
  }
}
